/* DietXP Knowledge Hub article behaviour (27 Sep 2026), shared by the 26 article templates.
   Reading progress, section highlighting in the contents list, the phone contents sheet,
   scroll hints on wide tables and a light entrance motion. The page works without it. */
(function () {
  'use strict';
  var root = document.querySelector('.dxa');
  if (!root || root.getAttribute('data-dxa-ready')) return;
  root.setAttribute('data-dxa-ready', '1');
  root.classList.add('dxa--js');

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true, addEventListener: function () {} };
  var main = root.querySelector('.dxa-main');
  var header = document.querySelector('header.header-section');

  /* Sticky header height, so anchors and the sticky contents land below it. Ella makes the
     header sticky only after DOMContentLoaded, so this runs again then and on load. */
  var offset = 96;
  function measure() {
    var h = 0;
    if (header) {
      var cs = window.getComputedStyle(header);
      if (cs.position === 'sticky' || cs.position === 'fixed') h = header.getBoundingClientRect().height + (parseFloat(cs.top) || 0);
    }
    offset = Math.round(h + 20);
    root.style.setProperty('--dxa-offset', offset + 'px');
  }
  measure();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(measure, 0); });
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure, { passive: true });
  if (header && 'ResizeObserver' in window) new ResizeObserver(measure).observe(header);

  /* Reading progress */
  var bar = root.querySelector('.dxa-progress__bar');
  var ticking = false;
  function progress() {
    ticking = false;
    if (!bar || !main) return;
    var r = main.getBoundingClientRect();
    var total = r.height - window.innerHeight * 0.6;
    var p = total > 0 ? Math.min(1, Math.max(0, (offset - r.top) / total)) : 1;
    bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { progress(); fabState(); }); } }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Contents: highlight the section being read */
  var toc = root.querySelector('.dxa-toc');
  var links = toc ? Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')) : [];
  var byId = {};
  links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
  var sections = Array.prototype.slice.call(root.querySelectorAll('.dxa-sec[id]')).filter(function (s) { return byId[s.id]; });
  var current = null;
  function setActive(id) {
    if (id === current) return;
    current = id;
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    var active = id && byId[id];
    if (active && desktop.matches && toc.scrollHeight > toc.clientHeight) {
      var t = active.offsetTop - toc.clientHeight / 2;
      toc.scrollTop = Math.max(0, t);
    }
  }
  function pickSection() {
    var line = offset + window.innerHeight * 0.25, id = null;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getBoundingClientRect().top <= line) id = sections[i].id; else break;
    }
    setActive(id);
  }
  if (sections.length) {
    window.addEventListener('scroll', function () { window.requestAnimationFrame(pickSection); }, { passive: true });
    pickSection();
  }

  /* Phone and tablet: floating Contents button opens the list as a bottom sheet */
  var fab = root.querySelector('.dxa-fab');
  var scrim = root.querySelector('.dxa-scrim');
  var closeBtn = toc ? toc.querySelector('.dxa-toc__close') : null;
  var inline = root.querySelector('.dxa-contents');
  var lastFocus = null, isOpen = false;
  function sheetMode() { return !desktop.matches; }
  var lastY = window.pageYOffset || 0, goingDown = false;
  function fabState() {
    if (!fab || !main) return;
    if (!sheetMode()) { fab.classList.remove('is-shown'); return; }
    var y = window.pageYOffset || 0;
    if (Math.abs(y - lastY) > 6) { goingDown = y > lastY; lastY = y; }
    var start = inline ? inline.getBoundingClientRect().bottom : 400;
    var end = main.getBoundingClientRect().bottom;
    /* out of the way while reading down, back as soon as the reader scrolls up */
    fab.classList.toggle('is-shown', start < 0 && end > window.innerHeight * 0.6 && (!goingDown || isOpen));
  }
  function syncSheetAttrs() {
    if (!toc) return;
    if (sheetMode()) {
      toc.setAttribute('role', 'dialog');
      toc.setAttribute('aria-modal', 'true');
      if (!isOpen) toc.setAttribute('aria-hidden', 'true');
    } else {
      if (isOpen) closeSheet(false);
      toc.removeAttribute('role'); toc.removeAttribute('aria-modal'); toc.removeAttribute('aria-hidden');
    }
  }
  var lockedOverflow = null;
  function lockScroll(on) {
    var el = document.documentElement;
    if (on) { lockedOverflow = el.style.overflow; el.style.overflow = 'hidden'; }
    else if (lockedOverflow !== null) { el.style.overflow = lockedOverflow; lockedOverflow = null; }
  }
  function openSheet() {
    if (!toc || isOpen) return;
    isOpen = true; lastFocus = document.activeElement; lockScroll(true);
    toc.removeAttribute('aria-hidden');
    toc.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    if (fab) fab.setAttribute('aria-expanded', 'true');
    var target = toc.querySelector('a.is-active') || closeBtn;
    window.setTimeout(function () { if (target) target.focus({ preventScroll: false }); }, 60);
  }
  function closeSheet(restore) {
    if (!toc || !isOpen) return;
    isOpen = false; lockScroll(false);
    toc.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    if (fab) fab.setAttribute('aria-expanded', 'false');
    if (sheetMode()) toc.setAttribute('aria-hidden', 'true');
    if (restore !== false && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  if (fab) fab.addEventListener('click', function () { if (isOpen) closeSheet(); else openSheet(); });
  if (closeBtn) closeBtn.addEventListener('click', function () { closeSheet(); });
  if (scrim) scrim.addEventListener('click', function () { closeSheet(); });
  links.forEach(function (a) { a.addEventListener('click', function () { if (isOpen) closeSheet(false); }); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var stops = Array.prototype.slice.call(toc.querySelectorAll('a[href],button')).filter(function (el) { return el.getClientRects().length; });
    if (!stops.length) return;
    var first = stops[0], last = stops[stops.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  syncSheetAttrs();
  if (desktop.addEventListener) desktop.addEventListener('change', function () { syncSheetAttrs(); fabState(); });

  /* Wide tables: show the "scroll sideways" hint only when the table really scrolls */
  var tables = Array.prototype.slice.call(root.querySelectorAll('.dxa-table'));
  function tableHints() {
    tables.forEach(function (t) {
      var s = t.querySelector('.dxa-table__scroll');
      if (s) t.classList.toggle('is-scrollable', s.scrollWidth > s.clientWidth + 4);
    });
  }
  tableHints();
  window.addEventListener('resize', tableHints, { passive: true });
  window.addEventListener('load', tableHints);
  /* tables in a closed details box or a hidden tab panel measure 0 at load; check again when they appear */
  if ('ResizeObserver' in window) {
    var tableRo = new ResizeObserver(tableHints);
    tables.forEach(function (t) { var s = t.querySelector('.dxa-table__scroll'); if (s) tableRo.observe(s); });
  }

  /* Entrance motion for boxes and cards (never for running text) */
  if (!reduceMotion.matches && 'IntersectionObserver' in window) {
    var anim = Array.prototype.slice.call(root.querySelectorAll('.dxa-anim'));
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    anim.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) el.classList.add('is-in'); else io.observe(el);
    });
    root.classList.add('dxa--motion');
  }

  /* Printing: show every answer */
  var reopened = [];
  window.addEventListener('beforeprint', function () {
    reopened = Array.prototype.slice.call(root.querySelectorAll('details:not([open])'));
    reopened.forEach(function (d) { d.setAttribute('open', ''); });
  });
  window.addEventListener('afterprint', function () { reopened.forEach(function (d) { d.removeAttribute('open'); }); reopened = []; });

  /* Share: the phone's own share sheet (WhatsApp and others), or copy the link */
  var share = root.querySelector('.dxa-share');
  function toast(msg) {
    var t = root.querySelector('.dxa-toast');
    if (!t) { t = document.createElement('div'); t.className = 'dxa-toast'; t.setAttribute('role', 'status'); root.appendChild(t); }
    t.textContent = msg; t.classList.add('is-shown');
    window.clearTimeout(t._h); t._h = window.setTimeout(function () { t.classList.remove('is-shown'); }, 2200);
  }
  if (share) share.addEventListener('click', function () {
    var link = root.getAttribute('data-url') || window.location.href.split('#')[0].split('?')[0];
    var title = (root.querySelector('.dxa-title') || {}).textContent || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: link }).catch(function () {});
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link).then(function () { toast('Link copied'); }, function () { window.prompt('Copy this link', link); });
    } else {
      window.prompt('Copy this link', link);
    }
  });

  /* Looping silent clips (.dxa-video, 6 Oct 2026): play muted only while on screen; the button pauses and resumes;
     with reduced motion the clip starts paused on its poster. */
  Array.prototype.forEach.call(root.querySelectorAll('.dxa-video'), function (fig) {
    var v = fig.querySelector('video'), b = fig.querySelector('.dxa-video__toggle');
    if (!v || !b) return;
    var paused = !!reduceMotion.matches, onScreen = false;
    v.muted = true;
    function sync() {
      b.classList.toggle('is-paused', paused);
      b.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      if (!paused && onScreen) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { paused = true; b.classList.add('is-paused'); b.setAttribute('aria-label', 'Play video'); });
      } else { v.pause(); }
    }
    b.addEventListener('click', function () { paused = !paused; sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { onScreen = e.isIntersecting; sync(); }); }, { threshold: 0.25 }).observe(v);
    } else { onScreen = true; }
    sync();
  });

  progress(); fabState();
})();
